import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _, { mapObject, object } from 'underscore';
import { makeStyles } from '@mui/styles';
import L from 'leaflet';
import {
	Button, Chip, Collapse, Divider, Drawer,
	FormControlLabel, Radio, RadioGroup, Slider,
	TextField, Typography, Checkbox, Card, Grid,
	ListItemText, ListItemIcon, ListItem, ListSubheader,
	List, FormGroup, ToggleButton, ToggleButtonGroup,
	Autocomplete
} from '@mui/material';
import { onUpdateLegend } from 'components/Map/actions/MapActions';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Page, Header, MapGeneric, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import validate from 'validate.js';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import ScannerIcon from '@mui/icons-material/Scanner';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import AppsIcon from '@mui/icons-material/Apps';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import {
	SetFormState,
	GetTopology2g, GetTopology3g, GetTopology4g,
	GetTopologyLabels2g, GetTopologyLabels3g, GetTopologyLabels4g,
} from '../../actions/MapDriveTestsActionsGeneric';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
	// Filter child
	// root: {
	// 	width: '100%',
	// 	maxWidth: 360,
	// 	backgroundColor: theme.palette.background.paper,
	// },
	nested: {
		paddingLeft: theme.spacing(4),
	},
	nestedTwo: {
		paddingLeft: theme.spacing(2),
	},
}));
const bands2g = [];
const bands3g = [];
const bands4g = ['700', '800', '900', '1800', '2100', '2600'];

const SideFiltersGeneric = (props) => {
	const { className, onClose, onFilter, filterDisabled, onClear, height, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));

	// Map
	const maps = useSelector(state => state.mapReducer.maps);
	const formState = useSelector((state) => state.mapDriveTestsReducer.formState);
	const mapOne = maps.filter(item => item.id === 'failures-map')[0];
	const topology2gData = useSelector(state => state.mapDriveTestsReducer.topology2gData);
	const topology3gData = useSelector(state => state.mapDriveTestsReducer.topology3gData);
	const topology4gData = useSelector(state => state.mapDriveTestsReducer.topology4gData);
	const topologyLabels2gData = useSelector(state => state.mapDriveTestsReducer.topologyLabels2gData);
	const topologyLabels3gData = useSelector(state => state.mapDriveTestsReducer.topologyLabels3gData);
	const topologyLabels4gData = useSelector(state => state.mapDriveTestsReducer.topologyLabels4gData);

	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	// Topology
	const [openTopology, setOpenTopology] = React.useState(true);
	const [openTopology4g, setOpenTopology4g] = React.useState(true);
	const [openTopology3g, setOpenTopology3g] = React.useState(false);
	const [openTopology2g, setOpenTopology2g] = React.useState(false);

	const [state, setState] = React.useState({
		topology2g900: false,
		topology2g1800: false,
		topologyLabels2g: false,
		topology3g900: false,
		topology3g2100: false,
		topologyLabels3g: false,
		topology4g800: false,
		topology4g2100: false,
		topology4g2600: false,
		topology4g700: false,
		topology4g900: false,
		topology4g1800: false,
		topologyLabels4g: true,
	});
	const [allBands4g, setAllBands4g] = React.useState(false);

	const {
		topology2g900, topology2g1800, topologyLabels2g,
		topology3g900, topology3g2100, topologyLabels3g,
		topology4g700, topology4g800, topology4g900, topology4g1800, topology4g2100, topology4g2600, topologyLabels4g
	} = state;

	// Topology
	const handleClickTopology = () => {
		setOpenTopology(!openTopology);
	};
	const handleClickTopology4g = () => {
		setOpenTopology4g(!openTopology4g);
	};
	const handleClickTopology3g = () => {
		setOpenTopology3g(!openTopology3g);
	};
	const handleClickTopology2g = () => {
		setOpenTopology2g(!openTopology2g);
	};

	const _removeLayerById = (map, id) => {
		map.RemoveLayerById(id);
	};

	// Use Effect
	const getSites = () => {
		// Filtro para sql
		const mapBoundsPoints = {
			northEast: {
				lat: 40.34595538154793,
				lng: -3.80702018737793
			},
			southWest: {
				lat: 40.30158888865566,
				lng: -3.89516830444336
			}
		};

		dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
		dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		setState({
			topology4g800: true,
			topology4g2100: true,
			topology4g2600: true,
			topology4g700: true,
			topology4g900: true,
			topology4g1800: true,
			topologyLabels4g: true });

		setAllBands4g(true);
	};

	useEffect(() => {
		getSites();
	}, []);

	const handleChangeTopology2g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		const _map = mapOne.control.mapContext.map;
		// const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		// const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();

		// console.log(
		// 	`center:${_map.getCenter()}\n`
		// 	+ `width:${width}\n`
		// 	+ `height:${height}\n`
		// 	+ `size in pixels:${_map.getSize()}`
		// );

		// Filtro para sql
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else
		if (event.target.name === 'topology2g900' && event.target.checked) {
			const index = bands2g.indexOf('900');
			if (index === -1) {
				bands2g.push('900');
			}
			dispatch(GetTopology2g(userId, bands2g, mapBoundsPoints));
			if (topologyLabels2g) {
				dispatch(GetTopologyLabels2g(userId, bands2g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology2g900' && !event.target.checked) {
			const index = bands2g.indexOf('900');
			if (index !== -1) {
				bands2g.splice(index, 1);
			}
			dispatch(GetTopology2g(userId, bands2g, mapBoundsPoints));
			dispatch(GetTopologyLabels2g(userId, bands2g, mapBoundsPoints));
		} else if (event.target.name === 'topology2g1800' && event.target.checked) {
			const index = bands2g.indexOf('1800');
			if (index === -1) {
				bands2g.push('1800');
			}
			dispatch(GetTopology2g(userId, bands2g, mapBoundsPoints));
			if (topologyLabels2g) {
				dispatch(GetTopologyLabels2g(userId, bands2g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology2g1800' && !event.target.checked) {
			const index = bands2g.indexOf('1800');
			if (index !== -1) {
				bands2g.splice(index, 1);
			}
			dispatch(GetTopology2g(userId, bands2g, mapBoundsPoints));
			dispatch(GetTopologyLabels2g(userId, bands2g, mapBoundsPoints));
		}
	};

	const handleChangeTopology3g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		const _map = mapOne.control.mapContext.map;
		// const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		// const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();

		// Filtro para sql
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else
		if (event.target.name === 'topology3g900' && event.target.checked) {
			const index = bands3g.indexOf('900');
			if (index === -1) {
				bands3g.push('900');
			}
			dispatch(GetTopology3g(userId, bands3g, mapBoundsPoints));
			if (topologyLabels3g) {
				dispatch(GetTopologyLabels3g(userId, bands3g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology3g900' && !event.target.checked) {
			const index = bands3g.indexOf('900');
			if (index !== -1) {
				bands3g.splice(index, 1);
			}
			dispatch(GetTopology3g(userId, bands3g, mapBoundsPoints));
			dispatch(GetTopologyLabels3g(userId, bands3g, mapBoundsPoints));
		} else if (event.target.name === 'topology3g2100' && event.target.checked) {
			const index = bands3g.indexOf('2100');
			if (index === -1) {
				bands3g.push('2100');
			}
			dispatch(GetTopology3g(userId, bands3g, mapBoundsPoints));
			if (topologyLabels3g) {
				dispatch(GetTopologyLabels3g(userId, bands3g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology3g2100' && !event.target.checked) {
			const index = bands3g.indexOf('2100');
			if (index !== -1) {
				bands3g.splice(index, 1);
			}
			dispatch(GetTopology3g(userId, bands3g, mapBoundsPoints));
			dispatch(GetTopologyLabels3g(userId, bands3g, mapBoundsPoints));
		}
	};

	const handleChangeTopology4g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });

		const _map = mapOne.control.mapContext.map;
		// const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		// const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();
		// const zoom = _map.getZoom();

		// Filtro para sql
		/*
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};
		*/
		const mapBoundsPoints = {
			northEast: {
				lat: 40.34595538154793,
				lng: -3.80702018737793
			},
			southWest: {
				lat: 40.30158888865566,
				lng: -3.89516830444336
			}
		};

		// console.log(mapBounds);
		// console.log(zoom);
		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else

		if (event.target.name === 'allBands4g' && event.target.checked) {
			bands4g.push('700');
			bands4g.push('800');
			bands4g.push('900');
			bands4g.push('1800');
			bands4g.push('2100');
			bands4g.push('2600');

			setState({
				topology4g800: true,
				topology4g2100: true,
				topology4g2600: true,
				topology4g700: true,
				topology4g900: true,
				topology4g1800: true,
			});
			setAllBands4g(true);

			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints)
			);
		} else if (event.target.name === 'allBands4g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels4g');
			bands4g.splice(bands4g.indexOf('700'));
			bands4g.splice(bands4g.indexOf('800'));
			bands4g.splice(bands4g.indexOf('900'));
			bands4g.splice(bands4g.indexOf('1800'));
			bands4g.splice(bands4g.indexOf('2100'));
			bands4g.splice(bands4g.indexOf('2600'));

			setOpenTopology(true);
			setState({
				topology4g800: false,
				topology4g2100: false,
				topology4g2600: false,
				topology4g700: false,
				topology4g900: false,
				topology4g1800: false,
				topologyLabels4gData: false
			});
			setAllBands4g(false);

			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g800' && event.target.checked) {
			const index = bands4g.indexOf('800');
			if (index === -1) {
				bands4g.push('800');
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g800' && !event.target.checked) {
			setAllBands4g(false);
			const index = bands4g.indexOf('800');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g2100' && event.target.checked) {
			const index = bands4g.indexOf('2100');
			if (index === -1) {
				bands4g.push('2100');
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g2100' && !event.target.checked) {
			setAllBands4g(false);
			const index = bands4g.indexOf('2100');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g2600' && event.target.checked) {
			const index = bands4g.indexOf('2600');
			if (index === -1) {
				bands4g.push('2600');
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g2600' && !event.target.checked) {
			setAllBands4g(false);
			const index = bands4g.indexOf('2600');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g700' && event.target.checked) {
			const index = bands4g.indexOf('700');
			if (index === -1) {
				bands4g.push('700');
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g700' && !event.target.checked) {
			setAllBands4g(false);
			const index = bands4g.indexOf('700');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g900' && event.target.checked) {
			const index = bands4g.indexOf('900');
			if (index === -1) {
				bands4g.push('900');
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g900' && !event.target.checked) {
			setAllBands4g(false);
			const index = bands4g.indexOf('900');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g1800' && event.target.checked) {
			const index = bands4g.indexOf('1800');
			if (index === -1) {
				bands4g.push('1800');
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g1800' && !event.target.checked) {
			setAllBands4g(false);
			const index = bands4g.indexOf('1800');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4g(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		}
	};

	const handleChangeTopologyLabels = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });

		const mapBounds = mapOne.control.mapContext.map.getBounds();

		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		if (event.target.name === 'topologyLabels2g' && event.target.checked) {
			dispatch(GetTopologyLabels2g(userId, bands2g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels2g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels2g');
		} else if (event.target.name === 'topologyLabels3g' && event.target.checked) {
			dispatch(GetTopologyLabels3g(userId, bands3g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels3g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels3g');
		} else if (event.target.name === 'topologyLabels4g' && event.target.checked) {
			dispatch(GetTopologyLabels4g(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels4g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels4g');
		}
	};

	useMemo(() => {
		if (mapOne) {
			if (topology2gData.length !== 0) {
				mapOne.control.updateTopology2g(topology2gData.topology2gDto, 'topology2g');
			}
		}
	}, [topology2gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels2gData.length !== 0 && topologyLabels2g) {
				mapOne.control.addTopologyLabels(topologyLabels2gData.topologyLabels2gDto, 'topologyLabels2g');
			}
		}
	}, [topologyLabels2gData]);

	useMemo(() => {
		if (mapOne) {
			if (topology3gData.length !== 0) {
				mapOne.control.updateTopology3g(topology3gData.topology3gDto, 'topology3g');
			}
		}
	}, [topology3gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels3gData.length !== 0 && topologyLabels3g) {
				mapOne.control.addTopologyLabels(topologyLabels3gData.topologyLabels3gDto, 'topologyLabels3g');
			}
		}
	}, [topologyLabels3gData]);

	useMemo(() => {
		if (mapOne) {
			if (topology4gData.length !== 0) {
				mapOne.control.updateTopology4g(topology4gData.topology4gDto, 'topology4g');
			}
		}
	}, [topology4gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels4gData.length !== 0 && topologyLabels4g) {
				mapOne.control.addTopologyLabels(topologyLabels4gData.topologyLabels4gDto, 'topologyLabels4g');
			}
		}
	}, [topologyLabels4gData]);

	const cardStyle = {
		height,
		overflow: 'auto'
	};

	return (
		<Card style={cardStyle}>
			<div className={classes.content}>
				<div className={classes.contentSection}>
					<Typography variant="h5">Layers</Typography>
					<FormControlLabel
						className={classes.nestedTwo}
						control={<Checkbox size="small" checked={topologyLabels4g} onChange={handleChangeTopologyLabels} name="topologyLabels4g" />}
						label="Site Names"
					/>
					<Divider />
					<FormControlLabel
						className={classes.nestedTwo}
						control={<Checkbox size="small" checked={allBands4g} onChange={handleChangeTopology4g} name="allBands4g" />}
						label="All Bands"
					/>
					<List
						component="nav"
						aria-labelledby="nested-list-subheader"
						// subheader={(
						// 	<ListSubheader component="div" id="nested-list-subheader">
						// 		Nested List Items
						// 	</ListSubheader>s
						// )}
						className={classes.root}
					>
						<ListItem button onClick={handleClickTopology}>
							<ListItemIcon>
								<BubbleChartIcon />
							</ListItemIcon>
							<ListItemText primary="Topology" />
							{openTopology ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={openTopology} timeout="auto" unmountOnExit>
							{/* <List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology2g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="2G" />
									{openTopology2g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology2g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology2g900} onChange={handleChangeTopology2g} name="topology2g900" />}
													label="G900"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology2g1800} onChange={handleChangeTopology2g} name="topology2g1800" />}
													label="G1800"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topologyLabels2g} onChange={handleChangeTopologyLabels} name="topologyLabels2g" />}
													label="Labels"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology3g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="3G" />
									{openTopology3g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology3g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology3g900} onChange={handleChangeTopology3g} name="topology3g900" />}
													label="U900"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology3g2100} onChange={handleChangeTopology3g} name="topology3g2100" />}
													label="U2100"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topologyLabels3g} onChange={handleChangeTopologyLabels} name="topologyLabels3g" />}
													label="Labels"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List> */}
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology4g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="4G" />
									{openTopology4g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology4g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g700} onChange={handleChangeTopology4g} name="topology4g700" />}
													label="L700"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g800} onChange={handleChangeTopology4g} name="topology4g800" />}
													label="L800"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g900} onChange={handleChangeTopology4g} name="topology4g900" />}
													label="L900"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g1800} onChange={handleChangeTopology4g} name="topology4g1800" />}
													label="L1800"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g2100} onChange={handleChangeTopology4g} name="topology4g2100" />}
													label="L2100"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g2600} onChange={handleChangeTopology4g} name="topology4g2600" />}
													label="L2600"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
						</Collapse>
					</List>
				</div>
			</div>
		</Card>
	);
};

SideFiltersGeneric.propTypes = {
	className: PropTypes.string,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	filterDisabled: PropTypes.bool,
	onClear: PropTypes.func,
	height: PropTypes.string
};

export default SideFiltersGeneric;
